var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148606",
    "data-name": "Rectangle 148606",
    width: 24,
    height: 24,
    transform: "translate(8996 -16190)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "specific-friends",
    transform: "translate(-8996 16190)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_friends_4314800",
    transform: "translate(8997.873 -16185.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11736",
    "data-name": "Group 11736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11735",
    "data-name": "Group 11735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8892",
    "data-name": "Path 8892",
    d: "M38.488,16.976A3.488,3.488,0,1,0,35,13.488,3.492,3.492,0,0,0,38.488,16.976Z",
    transform: "translate(-23.902 -10)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8893",
    "data-name": "Path 8893",
    d: "M10.488,16.976A3.488,3.488,0,1,0,7,13.488,3.492,3.492,0,0,0,10.488,16.976Z",
    transform: "translate(-4.78 -10)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8894",
    "data-name": "Path 8894",
    d: "M7.872,32.042a4.084,4.084,0,0,1-4.329,0A3.807,3.807,0,0,0,0,35.834v1.9A1.272,1.272,0,0,0,1.268,39h8.878a1.272,1.272,0,0,0,1.268-1.268v-1.9A3.807,3.807,0,0,0,7.872,32.042Z",
    transform: "translate(0 -25.053)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8895",
    "data-name": "Path 8895",
    d: "M39.7,32.042a4.084,4.084,0,0,1-4.329,0,3.784,3.784,0,0,0-1.764.579A4.423,4.423,0,0,1,35,35.834v1.9A1.891,1.891,0,0,1,34.514,39h7.464a1.272,1.272,0,0,0,1.268-1.268v-1.9A3.807,3.807,0,0,0,39.7,32.042Z",
    transform: "translate(-22.954 -25.053)",
    fill: "#0c0c0b"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4dae260b.svg";
export { ForwardRef as ReactComponent };